import React, { useState, useEffect } from "react";
import routes from "../../../app/routes";
import { columns } from "./Columns";
import DataTable from "react-data-table-component";
import axios from "axios";

export default function Table({ memberId }) {
  const [collection, setCollection] = useState();
  const [loaded, setLoaded] = useState(false);

  const updateCollection = () => {
    setLoaded(true);
    axios
      .get(routes.api.credits.list + `?q[student_id_eq]=${memberId}`)
      .then((resp) => {
        setCollection(resp.data.data);
        setLoaded(false);
      });
  };

  useEffect(() => {
    updateCollection();
  }, []);

  return (
    <>
      <div className="mt20">
        {loaded && <p className="text-center mt20">Processing...</p>}
        {!loaded && (
          <DataTable
            title=""
            columns={columns}
            data={collection}
            noDataComponent="No matching records found"
            persistTableHead={true}
            pagination
            paginationComponentOptions={{
              selectAllRowsItem: true,
              selectAllRowsItemText: "All",
            }}
          />
        )}
      </div>
    </>
  );
}
